"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeNamesEnum = void 0;
var ThemeNamesEnum;
(function (ThemeNamesEnum) {
    /**
     * MEMORESA
     */
    ThemeNamesEnum["MEM"] = "mem";
    ThemeNamesEnum["MEMORDER"] = "memOrder";
    ThemeNamesEnum["MEMHERITAGE"] = "memHeritage";
    ThemeNamesEnum["MEMEMERGENCY"] = "memEmergency";
    /**
     * TOP PRIORITY
     */
    ThemeNamesEnum["WIENERVEREIN"] = "wienerverein";
    ThemeNamesEnum["MYMORIA"] = "mymoria";
    ThemeNamesEnum["LIDL"] = "lidl";
    ThemeNamesEnum["VIG"] = "vig";
    ThemeNamesEnum["SENIORENNETZ"] = "seniorennetz";
    ThemeNamesEnum["WIENERSTAEDTISCHE"] = "wienerstaedtische";
    ThemeNamesEnum["WIENERVEREINWIENERSTAEDTISCHE"] = "wienervereinWienerstaedtische";
    ThemeNamesEnum["WIENERVEREIN_WIENERSTAEDTISCHE"] = "wienerverein_wienerstaedtische";
    ThemeNamesEnum["STADTLEIPZIG"] = "stadtleipzig";
    ThemeNamesEnum["HIGHCONTRAST"] = "highcontrast";
    ThemeNamesEnum["SIGNALIDUNA"] = "signaliduna";
    ThemeNamesEnum["ORDNUNGSWELT"] = "ordnungswelt";
    ThemeNamesEnum["ORDNUNGSSERVICE"] = "ordnungsservice";
    ThemeNamesEnum["BESTATTUNGENDUNKER"] = "bestattungendunker";
    ThemeNamesEnum["MUNDRECHTSANWAELTE"] = "mundrechtsanwaelte";
    ThemeNamesEnum["ORGART"] = "orgart";
    /**
     * UNCLASSIFIED
     */
    ThemeNamesEnum["PODCAST_OIDHL"] = "podcast_oidhl";
    ThemeNamesEnum["COMMERZBANK"] = "commerzbank";
    ThemeNamesEnum["ZANDURA"] = "zandura";
    ThemeNamesEnum["AOK"] = "aok";
    ThemeNamesEnum["PROINVESTA"] = "proinvesta";
    ThemeNamesEnum["HADITEHREANI"] = "haditeherani";
    ThemeNamesEnum["HSNW"] = "hsmw";
    ThemeNamesEnum["TILIADERM"] = "tiliaderm";
    ThemeNamesEnum["ENEL"] = "enel";
    ThemeNamesEnum["ERIXA"] = "erixa";
    ThemeNamesEnum["COMDIRECT"] = "comdirect";
    ThemeNamesEnum["MONUTA"] = "monuta";
    ThemeNamesEnum["VBSELECT"] = "vbselect";
    ThemeNamesEnum["DRK"] = "drk";
    ThemeNamesEnum["DRV"] = "drv";
    ThemeNamesEnum["DGV"] = "dgv";
    ThemeNamesEnum["SCHROEDERUNDPARTNER"] = "schroederundpartner";
    ThemeNamesEnum["VODAFONE"] = "vodafone";
    ThemeNamesEnum["NOVEMBER"] = "november";
})(ThemeNamesEnum = exports.ThemeNamesEnum || (exports.ThemeNamesEnum = {}));
